import JobManagePage from "../../../careJobs/pages/jobManagePage";
import Portal from "../../../../../platform/pages/business/portal";
import { Alert, Box } from "@mui/material";
import { useQuery } from "@apollo/client";
import { usePermissions } from "../../../../../platform/hooks/usePermissions";
import { Permissions } from "../../../../../platform/util/accessControl";
import { GET_BUSINESS_CATEGORIES } from "../../../../../platform/graphql/queries";
import { useSelectedBusiness } from "../../../../../platform/redux/store";
import { isAFHCategoryName } from "../../../../../platform/pages/business/defaultPageDialog";

const JobManagePortal = (props: any) => {
  const { checkPermission } = usePermissions();
  const selectedBusiness = useSelectedBusiness();
  const { data: categoriesData } = useQuery(GET_BUSINESS_CATEGORIES, {
    errorPolicy: "all",
  });
  const selectedCategory = (categoriesData?.getBusinessCategories || []).find(
    (c: any) =>
      Number(c?.id) === Number(selectedBusiness?.businessBasic?.businessCategoryId)
  );
  const isAFHBusiness =
    isAFHCategoryName(selectedCategory?.name) ||
    Boolean(selectedBusiness?.careSettings?.afhLicenseNumber);
  const canViewJobs =
    isAFHBusiness ||
    checkPermission(Permissions.BookingType.VIEW) ||
    checkPermission(Permissions.Job.VIEW) ||
    checkPermission(Permissions.Job.ADD) ||
    checkPermission(Permissions.Job.EDIT);

  if (!canViewJobs) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">You do not have permission to manage jobs.</Alert>
      </Box>
    );
  }
  return <Portal TabComponent={JobManagePage} title={"Manage Jobs"} props={props} />;
};

export default JobManagePortal;
